export function getMap(array: DictionaryItem[]) {
    return new Map(array.map(elem => [elem.name, { name: elem.display_name, id: elem.id }]));
}

export interface DictionaryItem {
    id: number,
    name: string,
    display_name: string
}